import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate, useLocation } from "react-router-dom";
import Swal from "sweetalert2";
import { viewerDisabledProps } from "../utils/permissions";
const EmployeeForm = () => {
  const [kitchens, setKitchens] = useState([]);
  const [formData, setFormData] = useState({
    kitchen_id: "",
    employee_name: "",
    father_name: "",
    mobile: "",
    gender: "",
    joining_date: "",
    exit_date: "",
    account_number: "",
    confirm_account_number: "",
    address: "",
    profile_image: null, // For file upload
    passbook_photo: null, // For passbook upload
    bank_name: "",
    ifsc_code: "",
    employee_code: "",
    pf_no: "",
    uan_no: "",
    esic_no: "",
    location: "",
    esic_benefits: "",
    epf_benefits: "",
    total_monthly_ctc: ""
  });
  const userId = localStorage.getItem("user_id");
  const [selectedFile, setSelectedFile] = useState(null);
  const [mobileExists, setMobileExists] = useState(false);
  const [checkingMobile, setCheckingMobile] = useState(false);
  const [base64Image, setBase64Image] = useState("");
  const [base64PassbookImage, setBase64PassbookImage] = useState("");
  const navigate = useNavigate();
  const location = useLocation();
  const rejoinFrom = location.state?.rejoinFrom || null;

  useEffect(() => {
    axios
      .get("https://ims-attendanceback.indevconsultancy.in/api/kitchen-list")
      .then((res) => setKitchens(res.data.kitchens))
      .catch((err) => console.error("Error loading kitchens", err));
  }, []);

  // Pre-fill the form when navigated here from the "Rejoin" button
  // on the Inactive Employees page. Keeps date_of_exiting empty (the new
  // record is active) and defaults joining_date to today.
  useEffect(() => {
    if (!rejoinFrom) return;
    const stripDate = (d) => (d ? String(d).split("T")[0] : "");
    const today = new Date().toISOString().split("T")[0];
    setFormData((prev) => ({
      ...prev,
      kitchen_id: rejoinFrom.kithchenid || "",
      employee_name: rejoinFrom.emp_name || "",
      father_name: rejoinFrom.father_name || "",
      mobile: rejoinFrom.emp_mobile_no || "",
      gender: rejoinFrom.gender || "",
      joining_date: today,           // fresh stint
      exit_date: "",                  // new row is active
      date_of_birth: stripDate(rejoinFrom.date_of_birth),
      account_number: rejoinFrom.account_no || "",
      confirm_account_number: rejoinFrom.account_no || "",
      address: rejoinFrom.address || "",
      bank_name: rejoinFrom.bank_name || "",
      ifsc_code: rejoinFrom.ifsc_code || "",
      employee_code: rejoinFrom.employee_code || "",
      pf_no: rejoinFrom.pf_no || "",
      uan_no: rejoinFrom.uan_no || "",
      esic_no: rejoinFrom.esic_no || "",
      location: rejoinFrom.location || "",
      esic_benefits: rejoinFrom.esic_benefits || "",
      epf_benefits: rejoinFrom.epf_benefits || "",
      total_monthly_ctc: rejoinFrom.total_monthly_ctc || "",
    }));
  }, [rejoinFrom]);
  console.log("Kitchens:", kitchens);
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleReset = () => {
    setFormData({
      kitchen_id: "",
      employee_name: "",
      father_name: "",
      mobile: "",
      joining_date: "",
      exit_date: "",
      address: "",
      account_number: "",
      confirm_account_number: "",
      profile_image: null,
      passbook_photo: null,
      added_by_userid_id: userId,
      pf_no: "",
      uan_no: "",
      esic_no: "",
      location: "",
      esic_benefits: "",
      epf_benefits: "",
      total_monthly_ctc: ""
    });
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];

    if (file && file instanceof Blob) {
      setSelectedFile(file); // Save file
      const reader = new FileReader();
      reader.onloadend = () => {
        setBase64Image(reader.result); // Base64 string
        console.log("Base64 Image:", reader.result);
      };
      reader.readAsDataURL(file); // ✅ Read correct file
    } else {
      console.error("Invalid file type");
    }
  };
  const handlePassbookFileChange = (e) => {
    const file = e.target.files[0];

    if (file && file instanceof Blob) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setBase64PassbookImage(reader.result); // Base64 string
        console.log("Base64 Passbook Image:", reader.result);
      };
      reader.readAsDataURL(file); // ✅ Read correct file
    } else {
      console.error("Invalid file type");
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const body = {
      ...formData,
      mobile: formData.mobile.trim(),
      joining_date: formData.joining_date || null,
      exit_date: formData.exit_date || null,
      added_by_userid_id: userId,
      profile_image: base64Image,
      passbook_photo: base64PassbookImage,
    };

    try {
      const res = await axios.post(
        "https://ims-attendanceback.indevconsultancy.in/api/register-employee",
        body
      );

      if (res.data.status === true) {
        Swal.fire("Success!", res.data.message, "success").then(() => {
          navigate("/employeeList"); // ✅ Go back to Employee List
        });
      } else {
        Swal.fire(
          "Error!",
          res.data.message || "Something went wrong",
          "error"
        );
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      // Surface the real reason instead of a generic message
      const serverMsg = error?.response?.data?.message;
      const status = error?.response?.status;
      const detail =
        serverMsg ||
        (status ? `HTTP ${status} — ${error.message}` : error.message) ||
        "Failed to submit the form";
      Swal.fire("Error!", detail, "error");
    }
  };

  return (
    <div className="bg-cream min-vh-100 py-2">
      <div className="container my-4">
        <div className="card shadow-lg">
          <div className="card-header bg-skyBlue text-white">
            <h5 className="mb-0">
              {rejoinFrom ? "Rejoin Employee" : "Add New Employee"}
            </h5>
          </div>
          <div className="card-body">
            <form onSubmit={handleSubmit}>
              {/* Kitchen Dropdown */}
              <div className="mb-4">
                <label htmlFor="kitchen_id" className="form-label fw-semibold">
                  Kitchen <span className="text-danger">*</span>
                </label>
                <select
                  className="form-select"
                  id="kitchen_id"
                  name="kitchen_id"
                  value={formData.kitchen_id}
                  onChange={handleChange}
                  required
                >
                  <option value="">-- Select Kitchen --</option>
                  {kitchens.map((kitchen) => (
                    <option key={kitchen.kitchenid} value={kitchen.kitchenid}>
                      {kitchen.kitchen_name}
                    </option>
                  ))}
                </select>
              </div>

              {/* Grid Form Fields */}
              <div className="row g-3">
                <div className="col-md-6">
                  <label className="form-label">Employee Code</label>
                  <input
                    type="text"
                    className="form-control"
                    name="employee_code"
                    placeholder="Enter Employee Code"
                    value={formData.employee_code}
                    onChange={handleChange}

                  />
                </div>
                <div className="col-md-6">
                  <label className="form-label">Employee Name</label>
                  <input
                    type="text"
                    className="form-control"
                    name="employee_name"
                    value={formData.employee_name}
                    onChange={handleChange}
                    placeholder="Enter full name"

                  />
                </div>

                <div className="col-md-6">
                  <label className="form-label">Father's / Husband's Name</label>
                  <input
                    type="text"
                    className="form-control"
                    name="father_name"
                    value={formData.father_name}
                    onChange={handleChange}
                    placeholder="Enter father's name"

                  />
                </div>

                <div className="col-md-6">
                  <label className="form-label">Mobile Number</label>
                  <input
                    type="tel"
                    className="form-control"
                    name="mobile"
                    value={formData.mobile}
                    onChange={handleChange}
                    pattern="[0-9]{10}"
                    maxLength="10"
                    placeholder="10-digit mobile number"
                    required
                  />
                  <span className="text-danger">
                    <p>{checkingMobile}</p>
                  </span>
                </div>

                <div className="col-mb-6">
                  <label htmlFor="kitchen_id" className="form-label fw-semibold"> Gender <span className="text-danger">*</span>
                  </label>
                  <select
                    className="form-select"
                    id="gender"
                    name="gender"
                    value={formData.gender}
                    onChange={handleChange}
                    required
                  >
                    <option value="">-- Select Gender --</option>
                    <option value="Male">Male</option>
                    <option value="Female">Female</option>
                    <option value="Other">Other</option>

                  </select>
                </div>


                <div className="col-md-3">
                  <label className="form-label">Date of Joining</label>
                  <input
                    type="date"
                    className="form-control"
                    name="joining_date"
                    value={formData.joining_date}
                    onChange={handleChange}

                  />
                </div>

                <div className="col-md-3">
                  <label className="form-label">Date of Exit</label>
                  <input
                    type="date"
                    className="form-control"
                    name="exit_date"
                    value={formData.exit_date}
                    onChange={handleChange}
                  />
                </div>
                <div className="col-md-6">
                  <label className="form-label">Date of Birth</label>
                  <input
                    type="date"
                    className="form-control"
                    name="date_of_birth"
                    value={formData.date_of_birth}
                    onChange={handleChange}
                  />
                </div>
                <div className="col-md-6">
                  <label className="form-label">PF No</label>
                  <input
                    type="text"
                    className="form-control"
                    name="pf_no"
                    value={formData.pf_no}
                    onChange={handleChange}
                    placeholder="Enter PF Number"
                  />
                </div>
                <div className="col-md-6">
                  <label className="form-label">UAN No</label>
                  <input
                    type="text"
                    className="form-control"
                    name="uan_no"
                    value={formData.uan_no}
                    onChange={handleChange}
                    placeholder="Enter UAN Number"
                  />
                </div>
                <div className="col-md-6">
                  <label className="form-label">ESIC No</label>
                  <input
                    type="text"
                    className="form-control"
                    name="esic_no"
                    value={formData.esic_no}
                    onChange={handleChange}
                    placeholder="Enter ESIC Number"
                  />
                </div>
                <div className="col-md-6">
                  <label className="form-label">Location</label>
                  <input
                    type="text"
                    className="form-control"
                    name="location"
                    value={formData.location}
                    onChange={handleChange}
                    placeholder="Enter Location"
                  />
                </div>
                <div className="col-md-6">
                  <label className="form-label">ESIC Benefits</label>
                  <select
                    className="form-select"
                    name="esic_benefits"
                    value={formData.esic_benefits}
                    onChange={handleChange}
                  >
                    <option value="">-- Select --</option>
                    <option value="Yes">Yes</option>
                    <option value="No">No</option>
                  </select>
                </div>

                <div className="col-md-6">
                  <label className="form-label">EPF Benefits</label>
                  <select
                    className="form-select"
                    name="epf_benefits"
                    value={formData.epf_benefits}
                    onChange={handleChange}
                  >
                    <option value="">-- Select --</option>
                    <option value="Yes">Yes</option>
                    <option value="No">No</option>
                  </select>
                </div>

                <div className="col-md-6">
                  <label className="form-label">Total Monthly CTC (A)</label>
                  <input
                    type="number"
                    className="form-control"
                    name="total_monthly_ctc"
                    value={formData.total_monthly_ctc}
                    onChange={handleChange}
                    placeholder="Enter Total Monthly CTC"
                    step="0.01"
                  />
                </div>

                <div className="col-md-6">
                  <label className="form-label">Bank Name</label>
                  <input
                    type="text"
                    className="form-control"
                    name="bank_name"
                    value={formData.bank_name || ""}
                    onChange={handleChange}
                    placeholder="Enter bank name"
                  />
                </div>
                <div className="col-md-6">
                  <label className="form-label">IFSC Code</label>
                  <input
                    type="text"
                    className="form-control"
                    name="ifsc_code"
                    value={formData.ifsc_code}
                    onChange={handleChange}
                  />
                </div>
                <div className="col-md-6">
                  <label className="form-label">Account Number</label>
                  <input
                    type="text"
                    className="form-control"
                    name="account_number"
                    value={formData.account_number}
                    onChange={handleChange}
                  />
                </div>
                <div className="col-md-6">
                  <label className="form-label">Confirm Account Number</label>
                  <input
                    type="password"
                    className="form-control"
                    name="confirm_account_number"
                    value={formData.confirm_account_number}
                    onChange={handleChange}
                    required
                  />
                </div>
                <div className="col-md-6">
                  <label className="form-label">Address</label>
                  <input
                    type="text"
                    className="form-control"
                    name="address"
                    value={formData.address}
                    onChange={handleChange}
                  />
                </div>
                <div className="col-md-6">
                  <label className="form-label">Profile Image</label>
                  <input
                    type="file"
                    className="form-control"
                    name="profile_image"
                    onChange={handleFileChange}
                  />
                </div>
                <div className="col-md-6">
                  <label className="form-label">Upload Passbook Photo</label>
                  <input
                    type="file"
                    className="form-control"
                    name="passbook_photo"
                    onChange={handlePassbookFileChange}
                    accept="image/*"
                  />
                </div>
              </div>

              {/* Buttons */}
              <div className="d-flex justify-content-end gap-2 mt-4">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={handleReset}
                >
                  Reset
                </button>
                <button type="submit" className="btn btn-primary">
                  {rejoinFrom ? "Save Rejoin" : "Save Employee"}
                </button>
              </div>

            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmployeeForm;
